<template>
  <div class="mt-8">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :items-per-page="5"
      sort-by="check_date"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 30, 60],
        'items-per-page-text': 'Տողեր մեկ էջի համար',
      }"
      @update:options="getDatabase()"
      sort-desc
      item-key="id"
      class="elevation-0 mt-10"
      :options.sync="options"
      :server-items-length="totalRecords"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="0"
                outlined
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                Ներբեռնել աշխատանքը
              </v-btn>
            </template>

            <v-card class="pa-3">
              <v-card-text>
                <v-file-input
                  ref="file"
                  v-model="file"
                  counter
                  label="Ֆայլի մուտքագրում"
                  multiple
                  placeholder="Select your files"
                  prepend-icon="mdi-paperclip"
                  :show-size="1000"
                >
                </v-file-input>
                <v-text-field
                  prepend-icon="mdi-format-header-pound"
                  v-model="editedItem.title"
                  label="Վերնագիր"
                >
                </v-text-field>
                <v-text-field
                  prepend-icon="mdi-account"
                  v-model="editedItem.author"
                  label="Հեղինակ"
                >
                </v-text-field>
                <v-text-field
                  prepend-icon="mdi-calendar-range"
                  v-model="editedItem.year"
                  type="number"
                  label="Տարի"
                >
                </v-text-field>
                <v-text-field
                  prepend-icon="mdi-city"
                  v-model="editedItem.publisher"
                  type="text"
                  label="Հրապարակման վայր"
                >
                </v-text-field>
                <v-autocomplete
                  prepend-icon="mdi-file-sign"
                  v-model="editedItem.category"
                  :items="categoryItems"
                  label="Աշխատանքի տեսակ"
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  outlined
                  @click="changeFileInput(editedItem)"
                >
                  Շարունակել
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5"
                  >Are you sure you want to delete this item?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
        </v-toolbar>
      </template>
      <template v-slot:item.upload_status="{ item }">
        <v-chip
          :color="item.upload_status === 'Success' ? 'success' : ''"
          class="mb-0 px-5"
          v-if="item.upload_status"
        >
          <span v-if="item.upload_status === 'Success' || item.upload_status === 'Failed'">{{
            item.upload_status
          }}</span>
          <span v-else>
            In Progress
            <v-progress-circular
              size="20"
              class="ms-3"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </span>
        </v-chip>
      </template>
      <template v-slot:item.original_filename="{ item }">
        <template
          v-if="
            item.original_filename.split('.').pop() === 'docx' ||
            item.original_filename.split('.').pop() === 'doc'
          "
        >
          <div class="d-flex align-center">
            <img src="@/assets/docx.svg" alt="" />
            <span class="ms-2">{{ item.original_filename }}</span>
          </div>
        </template>
        <template v-if="item.original_filename.split('.').pop() === 'pdf'">
          <div class="d-flex align-center">
            <img src="@/assets/pdf.svg" alt="" />
            <span class="ms-2">{{ item.original_filename }}</span>
          </div>
        </template>
        <template v-if="item.original_filename.split('.').pop() === 'txt'">
          <div class="d-flex align-center">
            <img src="@/assets/txt.svg" alt="" />
            <span class="ms-2">{{ item.original_filename }}</span>
          </div>
        </template>
      </template>
      <template v-slot:item.actions="{ item }">
        <!-- <v-icon
            :disabled="loading"
            small
            class="mr-2"
            @click="exportResults(item)"
          >
            mdi-download
          </v-icon> -->
        <v-icon small @click="deleteFromDatabase(item)"> mdi-delete </v-icon>
      </template>
      <!-- <template v-slot:footer.page-text> -->
      <!-- <v-btn color="primary" dark class="ma-2"> Button </v-btn> -->
      <!-- </template> -->
    </v-data-table>
  </div>
</template>

<script>
// import axios from "axios";

import { mapGetters } from "vuex";

export default {
  name: "Database",
  data: () => {
    return {
      url: process.env.VUE_APP_BACKEND_URL,
      file: null,
      headers: [
        // { text: "Լոգին", value: "user_login", sortable: false },
        // { text: "Փաստաթուղթ", value: "uri", sortable: false },
        {
          text: "Փաստաթղթի անվանումը",
          value: "original_filename",
          sortable: false,
        },
        { text: "Վերնագիր", value: "title", sortable: false },
        { text: "Հեղինակ", value: "author", sortable: false },
        { text: "Տարեթիվ", value: "year", sortable: false },
        { text: "Աշխատանքի տեսակ", value: "category", sortable: false },
        { text: "Հրապարակման վայր", value: "publisher", sortable: false },
        {
          text: "Կարգավիճակ",
          value: "upload_status",
          sortable: false,
        },
        // { text: "Արդյունքներ", value: "results", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      items: [],
      dialog: false,

      totalRecords: null,

      loading: true,
      options: {},
      categoryItems: [
        "դիպլոմային աշխատանք",
        "ատենախոսություն",
        "գիտական հոդված",
        "գիրք",
        "այլ",
      ],

      editedIndex: -1,
      editedItem: {
        user_login: "",
        document: "",
        original_filename: "",
        publisher: "",
        category: "",
        // title: "",
        // author: "",
        // year: 2022,
        upload_status: "",
      },
      defaultItem: {
        user_login: "",
        document: "",
        original_filename: "",
        publisher: "",
        category: "",
        // title: "",
        // author: "",
        // year: 2022,
        upload_status: "",
      },
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },
  methods: {
    getDataFromApi() {
      this.loading = true;
      this.getDatabase();
    },
    changeFileInput(item) {
      this.loading = true;

      let formData = new FormData();
      formData.append("file", this.file[0], this.file[0].name);
      formData.append("header", this.editedItem.title);
      formData.append("author", this.editedItem.author);
      formData.append("year", this.editedItem.year);
      formData.append("category", this.editedItem.category);
      formData.append("publisher", this.editedItem.publisher);

      fetch(`${this.url}/admin/add`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: this.getUser.jwt,
        },
      })
        .then((res) => res.text())
        .then((data) => {
          //   this.editedItem.url = data.url;
          console.log(item);
          console.log(data);
          //   this.getAddingDBStatus(item);
        })
        .then(() => {
          this.getDatabase();
          this.close();
        });
    },

    getDatabase() {
      // const { page, itemsPerPage } = this.options;
      let formdata = new FormData();
      formdata.append("page", this.options.page);
      formdata.append("per_page", this.options.itemsPerPage);
      formdata.append("filters", "[]");

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: this.getUser.jwt,
        },
        body: formdata,
        redirect: "follow",
      };
      setTimeout(() => {
        fetch(`${this.url}/admin/database`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            //   console.log(result.history);
            console.log(result);

            this.items = [...result.info];
            this.totalRecords = result.count;
            // clearInterval(checkInterval);
            for (let x of result.info) {
              x.upload_status === "Success" || x.upload_status === "Failed" ? "" : this.getDatabase();
            }
          })
          .catch((error) => console.log("error", error))
          .finally(() => (this.loading = false));
      }, 5000);
    },

    deleteFromDatabase(item) {
      let params = {
        id: item.id,
      };

      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      const config = {
        method: "POST",
        headers: {
          Authorization: this.getUser.jwt,
        },
      };

      fetch(`${this.url}/admin/update?${query}`, config).then(() =>
        this.getDataFromApi()
      );
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.file = null;
      });
    },
  },

  mounted() {
    this.getDatabase();
  },
};
</script>

